// LocalStorage utilities for the application
export const STORAGE_KEYS = {
  RECENT_UPLOADS: "recentUploads",
  CHAT_HISTORY: "chatHistory",
  USER_PREFERENCES: "userPreferences",
  AUTH_METHOD: "authMethod",
  LAST_LOGIN: "lastLogin",
  // Model 2 Keys
  MODEL2_NOTEBOOK_ID: "model2_notebook_id",
  MODEL2_CHAT_MODEL_ID: "model2_chat_model_id",
  MODEL2_EMBEDDING_MODEL_ID: "model2_embedding_model_id",
  MODEL2_SOURCE_IDS: "model2_source_ids",
  MODEL2_CHAT_SESSIONS: "model2_chat_sessions",
  MODEL2_ACTIVE_CHAT_SESSION_ID: "model2_active_chat_session_id",
} as const;

export const localStorageUtils = {
  get: <T>(key: string, defaultValue: T): T => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch {
      return defaultValue;
    }
  },

  set: <T>(key: string, value: T): void => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("Failed to save to localStorage:", error);
    }
  },

  remove: (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error("Failed to remove from localStorage:", error);
    }
  },

  clear: (): void => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error("Failed to clear localStorage:", error);
    }
  },
};
